/**
 * DevExtreme (ui/scroll_view.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
module.exports = require("./scroll_view/ui.scroll_view");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme/ui/scroll_view.js
// module id = ../../../../devextreme/ui/scroll_view.js
// module chunks = 3